
import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';

interface BusinessSettingsHeaderProps {
  handleBack: () => void;
  businessName: string;
  businessId: string;
  children?: React.ReactNode;
}

const BusinessSettingsHeader = ({ 
  handleBack, 
  businessName, 
  businessId,
  children 
}: BusinessSettingsHeaderProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className="w-full bg-brand-light">
      <header className="w-full py-4 max-w-screen-xl mx-auto px-4 md:px-8 flex items-center justify-between">
        <div className="flex items-center gap-4">
          {!isMobile && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleBack} 
              className="flex items-center text-gray-600 hover:text-gray-900"
            >
              <ChevronLeft size={16} />
              Back
            </Button>
          )}
          <h1 className={`text-xl font-semibold ${isMobile ? 'pl-2' : ''}`}>Business Settings</h1>
        </div>
        
        <div className="flex items-center gap-2">
          {children}
          
          {isMobile && (
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleBack} 
              className="flex items-center text-gray-600 hover:text-gray-900 ml-2"
            >
              <ChevronLeft size={16} />
              Back
            </Button>
          )}
        </div>
      </header>
    </div>
  );
};

export default BusinessSettingsHeader;
